// extracted by mini-css-extract-plugin
module.exports = {"fingerprintIframe":"summaryMultiEshopView_fingerprintIframe__2CHcO"};